<template>
<header class="menu">
  <section class="ico" v-on:click="openNav()">
    <span class="icoBar icoBarSpan0"></span>
    <span class="icoBar icoBarSpan1"></span>
  </section>
  <nav class="nav_0 none" role="navigation">
    <ul>
      <li v-on:click="scout()">
        <router-link class="route" to="intro">INTRO</router-link>
      </li>
      <li v-on:click="scout()">
        <router-link class="route" to="about">À PROPOS</router-link>
      </li>
      <li v-on:click="scout()">
        <router-link class="route" to="services">SERVICES</router-link>
      </li>
      <li v-on:click="scout()">
        <router-link class="route" to="works">FOLIO</router-link>
      </li>
      <li v-on:click="scout()">
        <router-link class="route" to="contact">CONTACT</router-link>
      </li>
    </ul>
  </nav>
</header>
</template>

<script>
export default {
  name: 'navigationSide',
  data () {
    return {
    }
  },
  mounted () {
    window.addEventListener('scroll', this.showNav)
  },
  methods: {
    openNav () {
      // change ico
      var ico = document.querySelector('.ico')
      ico.classList.toggle('ico_open')
      // open nav or close if already open
      var menu = document.querySelector('.menu nav')
      if (menu.classList.contains('nav_0')) {
        menu.classList.remove('none')
        menu.classList.remove('nav_0')
        menu.classList.toggle('nav_open')
      } else if (menu.classList.contains('nav_close')) {
        menu.classList.remove('none')
        menu.classList.remove('nav_close')
        menu.classList.toggle('nav_open')
      } else {
        this.closeNav()
      }
    },
    scout () {
      // change ico and close menu after timing
      var ico = document.querySelector('.ico')
      ico.classList.toggle('ico_open')
      setTimeout(() => { this.closeNav() }, 100)
    },
    closeNav () {
      // close nav
      var menu = document.querySelector('.menu nav')
      menu.classList.toggle('nav_close')
      menu.classList.remove('nav_open')
      setTimeout(function () { menu.classList.add('none') }, 500)
    },
    showNav () {
      // show nav top if 200px from top & window width 995px
      var scroll = window.scrollY
      var width = window.innerWidth
      var ico = document.querySelector('.ico')
      if (width > 995) {
        if (scroll > 200) {
          ico.classList.add('show')
        } else {
          ico.classList.remove('show')
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Template_Navigation_Side.vue